import { logger } from '@fiverr-private/obs';
import { Skill } from '../../types';
import { LOCAL_STORAGE_ORDER_KEY } from './constants';

type PersistedOrder = Partial<{
    [roleId: string]: {
        positions?: Partial<{
            [skillId: string]: number;
        }>;
    };
}>;

export type SkillOrServiceItem = Omit<Skill, 'type'>;

export function orderSkills<T extends SkillOrServiceItem>(tags: T[], roleId?: string | null) {
    try {
        if (!roleId || typeof window === 'undefined') {
            return tags;
        }

        const localStorageData = localStorage.getItem(LOCAL_STORAGE_ORDER_KEY);
        const orderByRoleId: PersistedOrder = localStorageData ? JSON.parse(localStorageData) : null;

        if (!orderByRoleId) {
            return tags;
        }

        return [...tags].sort((itemOne, itemTwo) => {
            const itemOneOrder = orderByRoleId[roleId]?.positions?.[itemOne.id] ?? 0;
            const itemTwoOrder = orderByRoleId[roleId]?.positions?.[itemTwo.id] ?? 0;

            return itemOneOrder - itemTwoOrder;
        });
    } catch (error) {
        logger.error('Failed to get tag order from local storage', {
            cause: error,
        });

        return tags;
    }
}
